import React from 'react';
import { connect } from 'react-redux';
import { TransferInfo } from './TransferInfo';

const TransferInfoContainerComponent = props => {
    return <TransferInfo {...props} />;
};

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        flags: state.featureFlagging?.get('data'),
    };
};

export const TransferInfoContainer = connect(mapStateToProps)(TransferInfoContainerComponent);
